/* eslint-disable */
// VENDORED from learning_brain_poc/chat4_pc.js (W7b / F3, POC commit 6ad5075e). Change: always sets window.V4Pc.
// Possible causes (PCs) of one chat, kept for the whole session: every cause the server has shown, its checks and their state,
// the override of a ruled-out cause (client snapshot for undo), and what a hand-over or a teach may send. Pure: no DOM.
// window.V4Pc = {accumulate, status, list, mapExtra, snapshot, restore, applyOverride, confirmedPid, handoverCauses, teachPayload, categoryLabel}
// Why: the server rebuilds its cards every turn (top five only), so a ruled-out cause and its checks vanished from the screen.
(function (root) {
  const MAX_MAP_PCS = 16;                       // matches diagmap.py MAX_PATTERNS
  const REASON = {setAside: 'set_aside', fixFailed: 'fix_failed'};
  const STEP = {confirmed: 'confirmed', notConfirmed: 'not_confirmed'};
  const CHECK = {done: 'done', failed: 'failed', current: 'current', pending: 'pending'};
  const STATE = {leading: 'leading', open: 'open', ruledOut: 'ruled_out', setAside: 'set_aside', fixFailed: 'fix_failed'};
  const STATE_RANK = {leading: 0, open: 1, set_aside: 2, ruled_out: 3, fix_failed: 3};
  const OPEN_UNTESTED_SHOWN = 5;
  const SYMPTOM_ID = /^SYM_/;

  // one entry per cause, in the order first seen; a later response refreshes it, a cause missing from it keeps its last values
  function accumulate(seen, cards, turn) {
    const now = new Set();
    (cards || []).forEach(c => {
      if (!c || !c.pid) return;
      now.add(c.pid);
      const old = seen[c.pid] || {};
      seen[c.pid] = {pid: c.pid, label: c.label || old.label || c.pid, post: typeof c.post === 'number' ? c.post : old.post,
        excluded: !!c.excluded, steps: (c.steps && c.steps.length) ? c.steps : (old.steps || []), matched: c.matched || old.matched || [],
        kills: c.kills || old.kills || [], firstTurn: old.firstTurn !== undefined ? old.firstTurn : turn, lastTurn: turn, current: true};
    });
    Object.keys(seen).forEach(pid => { if (!now.has(pid)) seen[pid].current = false; });
    return seen;
  }

  // the same rule as cdg_brain.step_outcome: this cause's own confirm / deny answer decides; step_results only for a step with neither
  function status(step, pid, S) {
    const obs = S.observed || [], res = S.stepResults || {}, cur = S.step;
    if (step.confirm_fact && obs.includes(step.confirm_fact)) return CHECK.done;
    if (step.deny_fact && obs.includes(step.deny_fact)) return CHECK.failed;
    if (!step.confirm_fact && !step.deny_fact && res[step.key] === STEP.confirmed) return CHECK.done;
    if (!step.confirm_fact && !step.deny_fact && res[step.key] === STEP.notConfirmed) return CHECK.failed;
    return cur && cur.pid === pid && cur.key === step.key ? CHECK.current : CHECK.pending;
  }

  const confirmedPid = S => (S.diag && S.diag.identified ? S.diag.pid : null) || S.awaitingFix || null;

  function stateOf(pc, S) {
    const why = (S.ruledReason || {})[pc.pid], ruled = (S.ruledOut || []).includes(pc.pid);
    if (ruled && why === REASON.setAside) return STATE.setAside;
    if (ruled && why === REASON.fixFailed) return STATE.fixFailed;
    if (ruled || pc.excluded) return STATE.ruledOut;
    const lead = (S.diag && S.diag.pid) || (S.step && S.step.pid);
    return pc.pid === lead ? STATE.leading : STATE.open;
  }

  // every cause seen, leading first, then open, set aside, ruled out; each with its checks and their status
  function list(S) {
    const order = Object.keys(S.pcSeen || {});
    return order.map((pid, i) => {
      const pc = S.pcSeen[pid], state = stateOf(pc, S);
      const steps = (pc.steps || []).slice().sort((a, b) => (a.order || a.position || 0) - (b.order || b.position || 0))
        .map(s => ({key: s.key, text: s.text, status: status(s, pid, S)}));
      return {pid, label: pc.label, post: pc.post, state, current: pc.current, steps, i};
    }).sort((a, b) => STATE_RANK[a.state] - STATE_RANK[b.state] || (b.current - a.current) || (b.post || 0) - (a.post || 0) || a.i - b.i);
  }

  // what /api/diagmap gets besides the latest turn: every cause seen so far, ruled-out ones too (flagged excluded, so the map keeps their
  // checks and the override button); at most MAX_MAP_PCS, open before ruled out, newest first. The server's tracked/overflow keeps its own cap.
  function mapExtra(S) {
    const seen = S.pcSeen || {}, ruled = new Set(S.ruledOut || []);
    const out = p => ruled.has(p) || !!seen[p].excluded;
    const pids = Object.keys(seen).sort((a, b) => (out(a) - out(b)) || (seen[b].current - seen[a].current) || seen[b].lastTurn - seen[a].lastTurn)
      .slice(0, MAX_MAP_PCS);
    const confidence = {};
    pids.forEach(p => { if (typeof seen[p].post === 'number' && Number.isFinite(seen[p].post)) confidence[p] = Math.min(Math.max(seen[p].post, 0), 1); });
    return {patterns: pids, excluded: pids.filter(out), confidence};
  }

  // ---------- override of a cause: the engineer trusts it even when it was ruled out ----------
  function snapshot(S) {
    return {ruledOut: (S.ruledOut || []).slice(), ruledReason: {...(S.ruledReason || {})}, round: S.round || 0, roundStart: S.roundStart || 0,
      unsureOnce: (S.unsureOnce || []).slice()};
  }
  function restore(S, snap) {
    Object.assign(S, {ruledOut: snap.ruledOut.slice(), ruledReason: {...snap.ruledReason}, round: snap.round, roundStart: snap.roundStart,
      unsureOnce: snap.unsureOnce.slice(), overridePid: '', overrideReasked: [], overrideUndo: null});
  }
  // returns the snapshot taken before the change; the pid leaves the ruled-out list, its reason and the turn it was ruled out in
  function applyOverride(S, pid) {
    const snap = snapshot(S);
    S.ruledOut = (S.ruledOut || []).filter(p => p !== pid);
    const reasons = {...(S.ruledReason || {})};
    delete reasons[pid];
    S.ruledReason = reasons;
    if (S.ruleTurn) delete S.ruleTurn[pid];
    S.overridePid = pid; S.overrideReasked = []; S.overrideUndo = snap;
    return snap;
  }

  // ---------- hand-over and teach ----------
  function categoryLabel(S) {
    const choice = (S.categoryChoices || []).find(c => c.name === S.category);
    return (choice && choice.label) || S.category || (S.info && S.info.category) || 'unknown';
  }
  // the confirmed cause is never listed as untested; a cause set aside is not "ruled out" and was not tested either
  function handoverCauses(S, reasonPid) {
    const skip = reasonPid || confirmedPid(S), reason = S.ruledReason || {}, ruledAll = S.ruledOut || [];
    const kind = p => reason[p];
    const ruled = ruledAll.filter(p => p !== skip && kind(p) !== REASON.fixFailed && kind(p) !== REASON.setAside);
    const failed = ruledAll.filter(p => p !== skip && kind(p) === REASON.fixFailed);
    const setAside = ruledAll.filter(p => p !== skip && kind(p) === REASON.setAside);
    const open = Object.keys(S.pcSeen || {}).filter(p => p !== skip && !ruledAll.includes(p) && !S.pcSeen[p].excluded).slice(0, OPEN_UNTESTED_SHOWN);
    return {confirmed: skip, ruled, failed, setAside, open};
  }

  // the hand-over text: what was asked, tried and ruled out; the cause that was confirmed is named once and never listed as untested
  function packetText(S, reason, reasonPid, nameOf, lineOf, now) {
    const c = handoverCauses(S, reasonPid), names = pids => pids.map(nameOf).join('; ') || 'none';
    const done = Object.entries(S.stepResults || {}).map(([k, v]) => `${k}: ${v === STEP.confirmed ? 'confirmed' : 'not confirmed'}`);
    return ['HAND-OVER', `Session: ${S.eid}`, `Time: ${now}`, `Category: ${categoryLabel(S)}`, `Reason: ${reason}`, 'Status: escalated', '',
      `First message: ${S.firstText || 'n/a'}`, '', 'Problem as described (symptoms and answers, in order):', ...(S.observed || []).map(n => `- ${lineOf(n)}`), '',
      ...(c.confirmed ? [`Cause confirmed: ${nameOf(c.confirmed)}`] : []),
      `Causes checked and ruled out: ${names(c.ruled)}`, `Causes confirmed but fix did not resolve it: ${names(c.failed)}`,
      `Causes set aside, not tested: ${names(c.setAside)}`, `Causes not yet tested: ${names(c.open)}`, '',
      'Steps done and their results:', ...(done.length ? done.map(x => `- ${x}`) : ['- none']), '',
      'Answers given, in order:', ...((S.answerLog || []).length ? S.answerLog.map(x => `- ${x}`) : ['- none'])].join('\n');
  }

  const isSymptom = (S, nid) => {
    const n = ((S.graph && S.graph.nodes) || []).find(x => x.nid === nid);
    return n ? n.type === 'symptom' : SYMPTOM_ID.test(String(nid));
  };
  // only what bears on the winning cause: the symptoms, answers linked to it and its own checks' answers; others (another case's
  // facts read from a pasted opening) must not be learned for it. Unknown cause or nothing linked: everything, as before.
  function teachPayload(S, pid) {
    const obs = S.observed || [], pc = (S.pcSeen || {})[pid];
    if (!pc) return {observed: obs.slice(), askedLog: (S.askedLog || []).slice()};
    const linked = new Set((pc.matched || []).map(m => m.nid));
    (pc.steps || []).forEach(s => { if (s.confirm_fact) linked.add(s.confirm_fact); if (s.deny_fact) linked.add(s.deny_fact); });
    const kept = obs.filter(n => isSymptom(S, n) || linked.has(n));
    if (!kept.length) return {observed: obs.slice(), askedLog: (S.askedLog || []).slice()};
    const dropped = new Set(obs.filter(n => !kept.includes(n)));
    return {observed: kept, askedLog: (S.askedLog || []).filter(e => !dropped.has(e.parent))};
  }

  const api = {MAX_MAP_PCS, REASON, STATE, CHECK, accumulate, status, list, mapExtra, snapshot, restore, applyOverride, confirmedPid, handoverCauses,
    packetText, teachPayload, categoryLabel};
  root.V4Pc = api;      // V5 (W7b): always the window global; under webpack `module` exists, so the POC branch never set it
})(typeof window !== 'undefined' ? window : globalThis);
